import * as actionTypes from './actionTypes';
import loadEstimate from './loadEstimate';
import saveToMyAccount from './saveToMyAccount';
import addEstimateToSelection from './share/addEstimateToSelection';
import initShareStore from './share/initShareStore';
import updateEstimateURL from '../helpers/updateEstimateURL';

export default (designId, { load = true, updateUrl = true } = {}) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SELECT_ESTIMATE,
    payload: {
      designId,
    },
  });
  if (load) {
    dispatch(loadEstimate(designId));
  }
  const design = getState().estimateBuilder.entities.estimates.byId[designId];

  if (!design.isLinked) {
    dispatch(saveToMyAccount(designId));
  }
  dispatch(initShareStore());
  dispatch(addEstimateToSelection(designId));

  if (updateUrl) {
    updateEstimateURL(design);
  }
};
